<template>
  <div class="row">
    <div class="col-md-12">
      <div v-if="!collapse">
        <div class="card card-body">
          <div class="row">
            <CustomMulti
              :label="$t('document_name')"
              size="6"
              :query="documentName"
              :list="documentNameList"
              :model="form.document_name"
              @data="setValue('document_name', $event)"
            />
            <!-- <div class="col-md-6">
              <label class="control-label">&nbsp;</label>
              <div>
                <a
                  class="btn btn-info"
                  v-if="form.document_name"
                  :href="form.document_name.link_file"
                  target="_blank"
                  ><i class="fa fa-download"></i
                ></a>
              </div>
            </div> -->
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-12">
      <div class="card card-body printableArea">
        <h3>
          <b>{{ "Daftar Drafting Memo Ditolak" }}</b>
          <!-- <span class="pull-right">#5669626</span> -->
        </h3>
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb arr-right bg-white">
            <li class="breadcrumb-item"><a href="#">Home</a></li>
            <li class="breadcrumb-item active" aria-current="page">
              {{ $t("drafting_list") }}
            </li>
          </ol>
        </nav>
        <hr />
        <div class="row">
          <p class="text-right h6 pl-3">Filtering Data</p>
        </div>

        <div class="row">
          <div class="col-md-6 col-sm-6">
            <div class="form-group">
              <CustomInput
                label="Nomor Memo"
                :model="customFilter.document_number"
                @data="setSearchValue('document_number', $event)"
                @clear="setSearchValue('document_number', $event)"
                label-block
                toggle-clear
              />
            </div>
            <div class="form-group">
              <CustomMulti
                label="Sifat Memo"
                :query="documentUrgency"
                :list="documentUrgencyList"
                :model="customFilter.document_urgency"
                @data="setSearchValue('document_urgency', $event)"
                @clear="setSearchValue('document_urgency', $event)"
                toggle-clear
                label-block
                close-on-select
              />
            </div>
          </div>
          <div class="col-md-6 col-sm-6">
            <div class="form-group">
              <CustomMulti
                label="Kecepatan Memo"
                :query="documentSpeed"
                :list="documentSpeedList"
                :model="customFilter.document_speed"
                @data="setSearchValue('document_speed', $event)"
                @clear="setSearchValue('document_speed', $event)"
                toggle-clear
                label-block
                close-on-select
              />
            </div>
            <div class="form-group">
              <CustomMulti
                label="Status"
                :list="documentApprovalList"
                :model="customFilter.final_approved"
                @data="setSearchValue('final_approved', $event)"
                @clear="setSearchValue('final_approved', $event)"
                toggle-clear
                label-block
                close-on-select
              />
            </div>
          </div>
          <div class="col-md-6 col-sm-6">
            <div class="form-group">
              <button
                type="button"
                class="btn btn-outline-secondary"
                @click="loadItems()"
              >
                Cari
              </button>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <!-- <div class="row m-b-10">
              <div class="col-lg-12">
                <a
                  class="btn btn-success"
                  href="javascript:void(0);"
                  @click="collapse = !collapse"
                  >Download template memo <i class="fa fa-download"></i
                ></a>
                <button
                  class="btn btn-success float-right"
                  @click="goToAddView()"
                >
                  Create
                </button>
              </div>
            </div> -->
            <vue-good-table
              mode="remote"
              :pagination-options="{
                enabled: true,
                setCurrentPage: curPage,
                jumpFirstOrLast : true,
              }"
              @on-page-change="onPageChange"
              @on-sort-change="onSortChange"
              @on-column-filter="onColumnFilter"
              @on-per-page-change="onPerPageChange"
              :totalRows="total"
              :columns="columns"
              :rows="rows"
              :isLoading.sync="isLoading"
              fixed-header
            >
              <template slot="table-row" slot-scope="props">
                <span v-if="props.column.field === 'id'">
                  <button
                    type="button"
                    @click="doDetail({ id: props.row.id })"
                    class="btn btn-success btn-sm"
                  >
                    <i class="mdi mdi-magnify"></i>
                  </button>
                  <button
                    v-if="props.row.editable"
                    type="button"
                    @click="doEdit({ id: props.row.id })"
                    class="btn btn-warning btn-sm"
                  >
                    <i class="mdi mdi-grease-pencil"></i>
                  </button>
                  <button
                    v-if="props.row.editable_approval"
                    type="button"
                    @click="openModal(props.row.id)"
                    class="btn btn-warning btn-sm"
                  >
                    <i class="mdi mdi-account-edit"></i>
                  </button>
                </span>
                <span v-else>
                  {{ props.formattedRow[props.column.field] }}
                </span>
              </template>
            </vue-good-table>
          </div>
        </div>
      </div>
    </div>
    <Modal
      v-show="isModalVisible"
      @close="closeModal"
      @action="onDelete(deleteData)"
      :draftingFileDetail="draftingFileDetail"
    />
  </div>
</template>
<script>
import axios from "axios";
import Modal from "@/components/modal/approval.vue";
export default {
  components: {
    Modal,
  },
  data() {
    return {
      curPage: 1,
      documentSpeedList: [],
      documentUrgencyList: [],
      documentApprovalList: [
        { value: 1, text: "Approved" },
        { value: 2, text: "Pending" },
        { value: 3, text: "Decline" },
        { value: 4, text: "Revision" },
        { value: 5, text: "Retract/Cancelled" },
        { value: 6, text: "Draft" },
      ],
      documentNameList: [],
      collapse: true,
      form: {
        document_name: null,
      },
      columns: [
        { label: "Action", field: "id", sortable: false },
        { label: "Nomor Memo", field: "document_number", sortable: false },
        { label: "Perihal", field: "subject" },
        { label: "Tanggal", field: "document_date" },
        { label: "Penanda Tangan", field: "signers_text", sortable: false },
        { label: "Drafter", field: "creator.name", sortable: false },
        { label: "Status", field: "final_approvement.name", sortable: false },
      ],
      rows: [],
      isLoading: false,
      total: 0,
      serverParams: {
        columnFilters: {},
        sort: [],
        page: 1,
        perPage: 10,
      },
      customFilter: {
        document_number: null,
        final_approved: null,
        document_urgency: null,
        document_speed: null,
      },
      isModalVisible: false,
      currentId: 0,
      modalTitle: "",
      modalContent: "",
      isConfirmation: false,
      ActionChangeable: null,
      draftingFileDetail: {},
    };
  },
  computed: {},
  async created() {
    let curPage = localStorage.getItem('drafting_file_declined_memo.curPage');
    curPage = curPage ? curPage : 1;
    this.curPage = curPage * 1;
  },
  async mounted() {
    const state = {
      loaded: false,
      isAdd: false,
      isEdit: false,
      isDetail: false,
    };
    this.$store.commit("drafting_file_declined_memo/STATE", state);
    await this.loadItems();
  },
  methods: {
    setValue(model, data) {
      this.form[model] = data;
    },
    setSearchValue(model, data) {
      this.customFilter[model] = data;
    },
    updateParams(newProps) {
      this.serverParams = Object.assign({}, this.serverParams, newProps);
    },

    onPageChange(params) {
      this.updateParams({ page: params.currentPage });
      this.loadItems();
      localStorage.setItem('drafting_file_declined_memo.curPage', params.currentPage);
    },

    onPerPageChange(params) {
      this.updateParams({ perPage: params.currentPerPage });
      this.loadItems();
    },

    onSortChange(params) {
      this.updateParams({
        sort: params,
      });
      this.loadItems();
    },

    onColumnFilter(params) {
      this.updateParams(params);
      this.loadItems();
    },
    async loadItems() {
      this.isLoading = true;

      let { perPage, page, sort } = this.serverParams;

      let {
        document_number,
        final_approved,
        document_urgency,
        document_speed,
      } = this.customFilter;

      let start = (page - 1) * perPage;
      let url =
        "drafting-file-declineds?perPage=" +
        perPage +
        "&page=" +
        start +
        "&jenis=memo";

      if (document_number) {
        url += "&number=" + document_number;
      }
      if (final_approved) {
        url += "&approved=" + final_approved.value;
      }
      if (document_urgency) {
        url += "&urgency=" + document_urgency.value;
      }
      if (document_speed) {
        url += "&speed=" + document_speed.value;
      }

      if (sort.length) {
        sort.forEach((item, index) => {
          url +=
            `&sort[${index}][field]=${item.field}` +
            `&sort[${index}][type]=${item.type}`;
        });
      }

      let resp = await axios.get(url);

      this.rows = resp.data.data;
      this.total = resp.data.recordsTotal;

      this.isLoading = false;
    },
    documentUrgency(query) {
      axios.get(`document_urgencies/list?s=${query}`).then((res) => {
        this.documentUrgencyList = res.data.items;
      });
    },
    documentSpeed(query) {
      axios.get(`document_speeds/list?s=${query}`).then((res) => {
        this.documentSpeedList = res.data.items;
      });
    },
    documentName(query) {
      axios.get(`clasification/list-active?s=${query}`).then((res) => {
        this.documentNameList = res.data.items;
      });
    },
    goToAddView() {
      this.$store.dispatch("drafting_file_declined/onAdd");
    },
    doDetail(val) {
      this.$store.dispatch("drafting_file_declined/onDetail", val);
    },
    doEdit(val) {
      this.$store.dispatch("drafting_file_declined/onEdit", val);
    },
    doDelete(val) {
      this.$store.dispatch("drafting_file_declined/onDelete", val);
    },
    closeModal() {
      this.isModalVisible = false;
    },
    onDelete() {
      this.isModalVisible = false;
    },
    openModal(id) {
      axios.get(`drafting-file-declined/${id}`).then((res) => {
        this.draftingFileDetail = res.data.data;
        this.isModalVisible = true;
      });
    },
    showModal(option) {
      this.isVisible = true;
      if (option.type == "submit") {
        if (option.data == 0) {
          this.modalTitle = "Simpan Data?";
          this.modalContent = "<p>Apakah anda yakin ingin menyimpan memo?</p>";
          this.isConfirmation = true;
          this.ActionChangeable = this.submit;
        } else if (option.data == 1) {
          this.modalTitle = "Kirim Data?";
          this.modalContent = "<p>Apakah anda yakin ingin mengirim memo?</p>";
          this.isConfirmation = true;
          this.ActionChangeable = this.submit;
        }
      } else if (option.type == "cancel") {
        this.modalTitle = "Kembali?";
        this.modalContent = "<p>Apakah anda yakin ingin kembali?</p>";
        this.isConfirmation = true;
        this.ActionChangeable = this.goBack;
      }
    },
  },
};
</script>
